var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1A1A1A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.334 5.147h13.333m-8.333 8.824V8.676m3.333 5.295V8.676m1.667 8.824H6.667c-.92 0-1.666-.79-1.666-1.765V6.03c0-.487.373-.882.833-.882h8.333c.46 0 .834.395.834.882v9.706c0 .975-.746 1.765-1.667 1.765m-5-12.353h3.333c.46 0 .834-.395.834-.882v-.883c0-.487-.373-.882-.834-.882H8.334c-.46 0-.833.395-.833.882v.883c0 .487.373.882.833.882"
})));
export default SvgDelete;